import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const abusech = defineConnector({
  identifier: "abusech",
  name: "abuse.ch",
  tagLine: "Threat intelligence feeds",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () =>
    "https://(urlhaus-api|threatfox-api|sslbl|feodotracker)\\.abuse\\.ch/api/.*",
  auth: (app) => headerAuth([{ name: "Auth-Key", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Get an API key",
      items: [
        {
          kind: "markdown",
          content:
            "Visit the [abuse.ch API documentation](https://abuse.ch/) and sign up for an API key from the specific service you want to use (URLhaus, ThreatFox, SSL Blacklist, or Feodo Tracker).",
        },
      ],
    },
    {
      title: "Copy and paste the API key into the field below",
      items: [
        {
          kind: "input",
          label: "abuse.ch API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://urlhaus-api.abuse.ch/api/",
  },
});
